module.exports = __webpack_public_path__ + "static/media/leafly-grey.68dbeeba.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/leafly-grey.svg
// module id = 2444
// module chunks = 0